<template lang="pug">
.vgame-result
  .vgame-headline
    template(v-if="whiteLabel")
      .back-btn(@click="back()")
        i.fa-solid.fa-left-long
        |  {{ $t("ui.back") }} 
    .d-flex.align-items-center(v-if="params && params[sportsType]")
      img.game-icon(:src="params[sportsType].thumbnail")
      span.game-name {{ $t(params[sportsType].gameName) }}
  .vgame-result-content
    table.table.responsive-table
      template(v-if="racingList.includes(parseInt(sportsType))")
        template(v-if="racingList1.includes(parseInt(sportsType))")
          table.table.responsive-table
            thead
              tr
                th(scope='col') {{ $t('ui.date') }}
                th(scope='col') 1st
                th(scope='col') 2nd
                th(scope='col') 3rd
                th(scope='col') {{ $tc("m.BT_OU", 2) }}
                th(scope='col') {{ $tc("m.BT_OE", 2) }}
            tbody
              tr(v-for="(item, key, index) in schedule.EFResult")
                td(:data-label="$t('ui.date')") {{ $dayjs(item.match_time).format("MM/DD/YYYY h:mm A") }}
                td(data-label="1st") 
                  span(v-if="item.dog1 == 1") {{ item.dog1_name }}
                  span(v-if="item.dog2 == 1") {{ item.dog2_name }}
                  span(v-if="item.dog3 == 1") {{ item.dog3_name }}
                  span(v-if="item.dog4 == 1") {{ item.dog4_name }}
                  span(v-if="item.dog5 == 1") {{ item.dog5_name }}
                  span(v-if="item.dog6 == 1") {{ item.dog6_name }}
                td(data-label="2nd") 
                  span(v-if="item.dog1 == 2") {{ item.dog1_name }}
                  span(v-if="item.dog2 == 2") {{ item.dog2_name }}
                  span(v-if="item.dog3 == 2") {{ item.dog3_name }}
                  span(v-if="item.dog4 == 2") {{ item.dog4_name }}
                  span(v-if="item.dog5 == 2") {{ item.dog5_name }}
                  span(v-if="item.dog6 == 2") {{ item.dog6_name }}
                td(data-label="3rd") 
                  span(v-if="item.dog1 == 3") {{ item.dog1_name }}
                  span(v-if="item.dog2 == 3") {{ item.dog2_name }}
                  span(v-if="item.dog3 == 3") {{ item.dog3_name }}
                  span(v-if="item.dog4 == 3") {{ item.dog4_name }}
                  span(v-if="item.dog5 == 3") {{ item.dog5_name }}
                  span(v-if="item.dog6 == 3") {{ item.dog6_name }}
                td(:data-label='$tc("m.BT_OU", 2)') 
                  .result.bg-danger(v-if="item.dog4 == 1 || item.dog5 == 1 || item.dog6 == 1") {{ $t('m.LOT_OVER') }}
                  .result.bg-primary(v-else) {{ $t('m.LOT_UNDER') }}
                td(:data-label='$tc("m.BT_OE", 2)') 
                  .result.bg-danger(v-if="item.dog1 == 1 || item.dog3 == 1 || item.dog5 == 1") {{ $t('m.LOT_ODD') }}
                  .result.bg-primary(v-else) {{ $t('m.LOT_EVEN') }}
        template(v-else-if="racingList2.includes(parseInt(sportsType))")
          table.table.responsive-table
            thead
              tr
                th(scope='col') {{ $t('ui.date') }}
                th(scope='col') 1st
                th(scope='col') 2nd
                th(scope='col') 3rd
                th(scope='col') 4th
                th(scope='col') 5th
                th(scope='col') {{ $t('ui.score') }}
                th(scope='col') {{ $t('ui.yellow') }} {{ $t('m.GC_OU') }}
                th(scope='col') {{ $t('ui.blue') }} {{ $t('m.GC_OU') }}
                th(scope='col') {{ $t('ui.yellow') }} {{ $t('m.GC_OE') }}
                th(scope='col') {{ $t('ui.blue') }} {{ $t('m.GC_OE') }}
            tbody
              tr(v-for="(item, key, index) in schedule.EFResult")
                td(:data-label="$t('ui.date')") {{ $dayjs(item.match_time).format("MM/DD/YYYY h:mm A") }}
                td(data-label="1st") 
                  .result.ball-blue(v-if="item.ball_1 == 'B'") B
                  .result.ball-yellow(v-else) Y
                td(data-label="2nd") 
                  .result.ball-blue(v-if="item.ball_2 == 'B'") B
                  .result.ball-yellow(v-else) Y
                td(data-label="3rd") 
                  .result.ball-blue(v-if="item.ball_3 == 'B'") B
                  .result.ball-yellow(v-else) Y
                td(data-label="4th") 
                  .result.ball-blue(v-if="item.ball_4 == 'B'") B
                  .result.ball-yellow(v-else) Y
                td(data-label="5th") 
                  .result.ball-blue(v-if="item.ball_5 == 'B'") B
                  .result.ball-yellow(v-else) Y
                td(:data-label="$t('ui.score')") {{ item.home_score }}-{{ item.away_score }}
                td(:data-label="$t('ui.yellow') + ' ' + $t('m.GC_OU')") 
                  .result.bg-danger(v-if="item.home_score>item.away_score") {{ $t('m.LOT_OVER') }}
                  .result.bg-primary(v-else) {{ $t('m.LOT_UNDER') }}
                td(:data-label="$t('ui.blue') + ' ' + $t('m.GC_OU')") 
                  .result.bg-danger(v-if="item.home_score<item.away_score") {{ $t('m.LOT_OVER') }}
                  .result.bg-primary(v-else) {{ $t('m.LOT_UNDER') }}
                td(:data-label="$t('ui.yellow') + ' ' + $t('m.GC_OE')") 
                  .result.bg-danger(v-if="item.home_score%2!=0") {{ $t('m.LOT_ODD') }}
                  .result.bg-primary(v-else) {{ $t('m.LOT_EVEN') }}
                td(:data-label="$t('ui.blue') + ' ' + $t('m.GC_OE')") 
                  .result.bg-danger(v-if="item.away_score%2!=0") {{ $t('m.LOT_ODD') }}
                  .result.bg-primary(v-else) {{ $t('m.LOT_EVEN') }}
        template(v-else-if="racingList3.includes(parseInt(sportsType))")
          table.table.responsive-table
            thead
              tr
                th(scope='col') {{ $t('ui.date') }}
                th(scope='col') {{ $t('ui.team') }}
                th(scope='col') {{ $t('ui.winner') }}
                th(scope='col') {{ $tc("m.BT_OU", 2) }}
                th(scope='col') {{ $tc("m.BT_OE", 2) }}
            tbody
              tr(v-for="(item, key, index) in schedule.EFResult")
                td(:data-label="$t('ui.date')") {{ $dayjs(item.match_time).format("MM/DD/YYYY h:mm A") }}
                td(:data-label="$t('ui.team')")
                  .result.bg-warning(v-if="item.team_1 == 1 || item.team_4 == 1 || item.team_7 == 1 || item.team_10 == 1") A
                  .result.bg-secondary(v-if="item.team_2 == 1 || item.team_5 == 1 || item.team_8 == 1 || item.team_11 == 1") B
                  .result.bg-info(v-if="item.team_3 == 1 || item.team_6 == 1 || item.team_9 == 1 || item.team_12 == 1") C
                td(:data-label="$t('ui.winner')") 
                  span(v-if="item.team_1 == 1") {{ item.team_1_name }}
                  span(v-if="item.team_2 == 1") {{ item.team_2_name }}
                  span(v-if="item.team_3 == 1") {{ item.team_3_name }}
                  span(v-if="item.team_4 == 1") {{ item.team_4_name }}
                  span(v-if="item.team_5 == 1") {{ item.team_5_name }}
                  span(v-if="item.team_6 == 1") {{ item.team_6_name }}
                  span(v-if="item.team_7 == 1") {{ item.team_7_name }}
                  span(v-if="item.team_8 == 1") {{ item.team_8_name }}
                  span(v-if="item.team_9 == 1") {{ item.team_9_name }}
                  span(v-if="item.team_10 == 1") {{ item.team_10_name }}
                  span(v-if="item.team_11 == 1") {{ item.team_11_name }}
                  span(v-if="item.team_12 == 1") {{ item.team_12_name }}                
                td(:data-label='$tc("m.BT_OU", 2)') 
                  .result.bg-danger(v-if="item.team_7 == 1 || item.team_8 == 1 || item.team_9 == 1 || item.team_10 == 1 || item.team_11 == 1 || item.team_12 == 1") {{ $t('m.LOT_OVER') }}
                  .result.bg-primary(v-else) {{ $t('m.LOT_UNDER') }}
                td(:data-label='$tc("m.BT_OE", 2)') 
                  .result.bg-danger(v-if="item.team_1 == 1 || item.team_3 == 1 || item.team_5 == 1 || item.team_7 == 1 || item.team_9 == 1 || item.team_11 == 1") {{ $t('m.LOT_ODD') }}
                  .result.bg-primary(v-else) {{ $t('m.LOT_EVEN') }}
        template(v-else-if="racingList4.includes(parseInt(sportsType))")
          table.table.responsive-table
            thead
              tr
                th(scope='col') {{ $t('ui.date') }}
                th(scope='col') {{ $t('ui.ball_1') }}
                th(scope='col') {{ $t('ui.ball_2') }}
                th(scope='col') {{ $t('ui.ball_3') }}
                th(scope='col') {{ $t("ui.red") }}
                th(scope='col') {{ $t("ui.yellow") }}
                th(scope='col') {{ $t("ui.blue") }}
                th(scope='col') {{ $t("ui.green") }}
            tbody
              tr(v-for="(item, key, index) in schedule.EFResult")
                td(:data-label="$t('ui.date')") {{ $dayjs(item.match_time).format("MM/DD/YYYY h:mm A") }}
                td(:data-label="$t('ui.ball_1')")
                  .result(:class="'ball-c' + item.ball_1.toLowerCase()") {{ item.ball_1 }}
                td(:data-label="$t('ui.ball_2')")
                  .result(:class="'ball-c' + item.ball_2.toLowerCase()") {{ item.ball_2 }}
                td(:data-label="$t('ui.ball_3')")
                  .result(:class="'ball-c' + item.ball_3.toLowerCase()") {{ item.ball_3 }}
                td(:data-label="$t('ui.red')") {{ item.red_score }}
                td(:data-label="$t('ui.yellow')") {{ item.yellow_score }}
                td(:data-label="$t('ui.blue')") {{ item.blue_score }}
                td(:data-label="$t('ui.green')") {{ item.green_score }}
        .tab-content(v-if="racingList5.includes(parseInt(sportsType))")
          table.table.responsive-table
            thead
              tr.text-white.result-bg
                th(scope='col') {{ $t('ui.date') }}
                th(scope='col') {{ $t('ui.home') }}
                th(scope='col') {{ $t('ui.away') }}
                th(scope='col') {{ $t('ui.score') }}
                th(scope='col') {{ $t("ui.round1") }}
                th(scope='col') {{ $t("ui.round2") }}
                th(scope='col') {{ $t("ui.round3") }}
            tbody
              tr(v-for="(item, key, index) in schedule.EFResult")
                td(:data-label="$t('ui.date')") {{ $dayjs(item.match_time).format("MM/DD/YYYY h:mm A") }}
                td(:data-label="$t('ui.home')") {{ item.home_team_name }}
                td(:data-label="$t('ui.away')") {{ item.away_team_name }}
                td(:data-label="$t('ui.score')") {{ item.home_score }} - {{ item.away_score }}
                td(:data-label="$t('ui.round1')")
                  .rounded-lg.d-inline.px-2.py-1(:class="item.r1_result.includes('A') || item.r1_result.includes('B') ? 'team1': 'team2'")  {{ item.roundone_firstplace }}
                td(:data-label="$t('ui.round2')")
                  .rounded-lg.d-inline.px-2.py-1(:class="item.r2_result.includes('A') || item.r2_result.includes('B') ? 'team1': 'team2'")  {{ item.roundtwo_firstplace }}
                td(:data-label="$t('ui.round3')")
                  .rounded-lg.d-inline.px-2.py-1(:class="item.r3_result.includes('A') || item.r3_result.includes('B') ? 'team1': 'team2'")  {{ item.roundthree_firstplace }}
        .tab-content(v-if="racingList6.includes(parseInt(sportsType))")
          table.table.responsive-table
            thead
              tr.text-white.result-bg
                th(scope='col') {{ $t('ui.date') }}
                th(scope='col') {{ $t('ui.home') }}
                th(scope='col') {{ $t('ui.away') }}
                th(scope='col') {{ $t('ui.score') }}
                th(scope='col') {{ $t("ui.round1") }}
                th(scope='col') {{ $t("ui.round2") }}
                th(scope='col') {{ $t("ui.round3") }}
            tbody
              tr(v-for="(item, key, index) in schedule.EFResult")
                td(:data-label="$t('ui.date')") {{ $dayjs(item.match_time).format("MM/DD/YYYY h:mm A") }}
                td(:data-label="$t('ui.home')") {{ item.team_home_name }}
                td(:data-label="$t('ui.away')") {{ item.team_away_name }}
                td(:data-label="$t('ui.score')") {{ item.home_score }} - {{ item.away_score }}
                td(:data-label="$t('ui.round1')")
                  .result(:class="formatWinner(item.r1_result) == '1' ? 'ball-blue' : 'ball-red'") {{ $t('m.CF_'+formatWinner(item.r1_result)) }}
                td(:data-label="$t('ui.round2')")
                  .result(:class="formatWinner(item.r2_result) == '1' ? 'ball-blue' : 'ball-red'") {{ $t('m.CF_'+formatWinner(item.r2_result)) }}
                td(:data-label="$t('ui.round3')")
                  .result(:class="formatWinner(item.r3_result) == '0' ? 'ball-green' : formatWinner(item.r3_result) == '1' ? 'ball-blue' : 'ball-red'") {{ $t('m.CF_'+formatWinner(item.r3_result)) }}
        .tab-content(v-if="racingList7.includes(parseInt(sportsType))")
          table.table.responsive-table
            thead
              tr.text-white.result-bg
                th(scope='col') {{ $t('ui.date') }}
                th(scope='col') {{ $t('ui.home') }}
                th(scope='col') {{ $t('ui.away') }}
                th(scope='col') {{ $t('ui.score') }}
                th(scope='col') {{ $t("ui.round1") }}
                th(scope='col') {{ $t("ui.round2") }}
                th(scope='col') {{ $t("ui.round3") }}
                th(scope='col') {{ $t("ui.round1_1stBoom") }}
                th(scope='col') {{ $t("ui.round2_1stBoom") }}
                th(scope='col') {{ $t("ui.round3_1stBoom") }}
            tbody
              tr(v-for="(item, key, index) in schedule.EFResult")
                td(:data-label="$t('ui.date')") {{ $dayjs(item.match_time).format("MM/DD/YYYY h:mm A") }}
                td(:data-label="$t('ui.home')") {{ item.team_home_name }}
                td(:data-label="$t('ui.away')") {{ item.team_away_name }}
                td(:data-label="$t('ui.score')") {{ item.home_score }} - {{ item.away_score }}
                td(:data-label="$t('ui.round1')")
                  .result(:class="formatWinner(item.r1_result) == '1' ? 'ball-blue' : 'ball-red'") {{ $t('m.EF8_'+formatWinner(item.r1_result)) }}
                td(:data-label="$t('ui.round2')")
                  .result(:class="formatWinner(item.r2_result) == '1' ? 'ball-blue' : 'ball-red'") {{ $t('m.EF8_'+formatWinner(item.r2_result)) }}
                td(:data-label="$t('ui.round3')")
                  .result(:class="formatWinner(item.r3_result) == '0' ? 'ball-green' : formatWinner(item.r3_result) == '1' ? 'ball-blue' : 'ball-red'") {{ $t('m.EF8_'+formatWinner(item.r3_result)) }}
                td(:data-label="$t('ui.round1_1stBoom')")
                  .result(:class="formatWinner(item.r1_result,true) == '1' ? 'ball-blue' : 'ball-red'") {{ $t('m.EF8_'+formatWinner(item.r1_result,true)) }}
                td(:data-label="$t('ui.round2_1stBoom')")
                  .result(:class="formatWinner(item.r2_result,true) == '1' ? 'ball-blue' : 'ball-red'") {{ $t('m.EF8_'+formatWinner(item.r2_result,true)) }}
                td(:data-label="$t('ui.round3_1stBoom')")
                  .result(:class="formatWinner(item.r3_result,true) == '0' ? 'ball-green' : formatWinner(item.r3_result,true) == '1' ? 'ball-blue' : 'ball-red'") {{ $t('m.EF8_'+formatWinner(item.r3_result,true)) }}
        .tab-content(v-else-if="[44,43,42,41,47,52,53].includes(parseInt(sportsType))")
          table.table.responsive-table
            thead
              tr
                th(scope='col') {{ $t('ui.date') }}
                th(scope='col') {{ $t('ui.home') }}
                th(scope='col') {{ $t('ui.away') }}
                th(scope='col') {{ $t('ui.score') }}
                th(scope='col') {{ $t("ui.round1") }}
                th(scope='col') {{ $t("ui.round2") }}
                th(scope='col') {{ $t("ui.round3") }}
            tbody
              tr(v-for="(item, key, index) in schedule.EFResult")
                td(:data-label="$t('ui.date')") {{ $dayjs(item.match_time).format("MM/DD/YYYY h:mm A") }}
                td(:data-label="$t('ui.home')") {{ item.team_home_name }}
                td(:data-label="$t('ui.away')") {{ item.team_away_name }}
                td(:data-label="$t('ui.score')") {{ item.home_score }} - {{ item.away_score }}
                td(:data-label="$t('ui.round1')")
                  .result(:class="formatWinner(item.r1_result) == '1' ? 'ball-blue' : 'ball-red'") {{ $t('m.CF_'+formatWinner(item.r1_result)) }}
                td(:data-label="$t('ui.round2')")
                  .result(:class="formatWinner(item.r2_result) == '1' ? 'ball-blue' : 'ball-red'") {{ $t('m.CF_'+formatWinner(item.r2_result)) }}
                td(:data-label="$t('ui.round3')")
                  .result(:class="formatWinner(item.r3_result) == '0' ? 'ball-green' : formatWinner(item.r3_result) == '1' ? 'ball-blue' : 'ball-red'") {{ $t('m.CF_'+formatWinner(item.r3_result)) }}
      template(v-else-if="efightList.includes(parseInt(sportsType))")
        table.table.responsive-table
          thead
            tr
              th(scope='col') {{ $t('ui.date') }}
              th(scope='col') {{ $t('ui.match') }}
              th(scope='col') {{ $t('ui.score') }}
              th(scope='col') {{ $t('ui.winner') }}
              template(v-if="![41,47,52,53].includes(parseInt(sportsType))")
                th(scope='col' v-if="[42].includes(parseInt(sportsType))") {{ $t('ui.ko') }}
                th(scope='col' v-else) {{ $tc("m.BT_OU", 1) }}
          tbody
            tr(v-for="(item, key, index) in schedule.EFResult")
              td(:data-label="$t('ui.date')") {{ $dayjs(item.match_time).format("MM/DD/YYYY h:mm A") }}
              td(:data-label="$t('ui.match')") {{ item.home_name_en }} -vs- {{ item.away_name_en }}
              td(:data-label="$t('ui.score')") {{ item.score }}
              td(:data-label="$t('ui.winner')") 
                .result(:class="item.home_win == 1 ? 'bg-danger' : 'bg-primary'") {{ $t('m.LOT_'+item.home_win) }}
              template(v-if="![41,47,52,53].includes(parseInt(sportsType))")
                template(v-if="[42].includes(parseInt(sportsType))")
                  td(:data-label="$t('ui.ko')")
                    .result(:class="item.over_under == 'odd' ? 'bg-danger' : 'bg-primary'") {{ $t('m.LOT_'+item.over_under.toUpperCase()) }}
                template(v-else)
                  td(:data-label="$tc('m.BT_OU', 1)")
                    .result(:class="item.over_under == 'over' ? 'bg-danger' : 'bg-primary'") {{ $t('m.LOT_'+item.over_under.toUpperCase()) }}

</template>

<script>
import config from "@/config";
import errors from "@/errors";
import SpinButton from "@/components/ui/SpinButton";
import mixinExt from "@/library/mixinExt.js";

export default {
  components: {
    SpinButton
  },
  mixins: [mixinExt],
  data() {
    return {
      sportsType: null,
      title: "",
      url: "",
      img: "",
      domain: "",
      tabs: 0,
      result: []
    };
  },
  computed: {
    params() {
      return config.params;
    },
    efightList() {
      return config.efightList;
    },
    racingList() {
      return config.racingList;
    },
    racingList1() {
      return config.racingList1;
    },
    racingList2() {
      return config.racingList2;
    },
    racingList3() {
      return config.racingList3;
    },
    racingList4() {
      return config.racingList4;
    },
    racingList5() {
      // console.log(this.schedule.EFResult);
      return config.racingList5;
    },
    racingList6() {
      return config.racingList6;
    },
    racingList7() {
      return config.racingList7;
    },
    whiteLabel() {
      return config.whiteLabel == "1";
    }
  },
  created() {},
  destroyed() {},
  mounted() {
    var q = this.$route.query;
    // console.log(q);

    if (q.q) {
      this.sportsType = q.q;
      this.title = q.n.replace("$", "+");
      // this.url = q.u;
      // this.domain = this.extractDomain(q.u);
      setTimeout(() => {
        this.query();
      }, 500);
    }
  },
  methods: {
    back() {
      this.$router.push("/prematch");
    },
    getTab(e) {
      return config.sports4dTab[100 + e];
    },
    extractDomain(url) {
      var domain;
      //find & remove protocol (http, ftp, etc.) and get domain
      if (url.indexOf("://") > -1) {
        domain = url.split("/")[2];
      } else {
        domain = url.split("/")[0];
      }

      //find & remove www
      if (domain.indexOf("www.") > -1) {
        domain = domain.split("www.")[1];
      }

      domain = domain.split(":")[0]; //find & remove port number
      domain = domain.split("?")[0]; //find & remove url params

      return domain;
    },
    query() {
      // this function is in mixinExt.js
      this.getEFResult(this.sportsType).then(() => {
        // console.log(this.schedule);
      });
    },
    getImage(e) {
      return config.getSportsImage(e);
    },
    formatWinner(result, is1stBomb = 0) {
      if (!result || result === "0") return "0";

      if (typeof result === "string") {
        let result_trimed = result.trimStart().trimEnd();
        if (is1stBomb == 1) {
          if (result_trimed.substring(1).startsWith("H")) return "1";
          if (result_trimed.substring(1).startsWith("A")) return "2";
        } else {
          if (result_trimed.startsWith("H")) return "1";
          if (result_trimed.startsWith("A")) return "2";
        }
      }

      return "0";
    }
  }
};
</script>

<!-- <style>
table {
  border: 1px solid #ccc;
  border-collapse: collapse;
  margin: 0;
  padding: 0;
  width: 100%;
  table-layout: fixed;
}

table caption {
  font-size: 1.5em;
  margin: .5em 0 .75em;
}

table tr {
  background-color: #f8f8f8;
  border: 1px solid #ddd;
  padding: .35em;
}

table th,
table td {
  padding: .625em;
  text-align: center;
}

table th {
  font-size: .85em;
  letter-spacing: .1em;
  text-transform: uppercase;
  /* background-color: #0d3a64; */
  /* background-image: url(/images/egame/header-bg.jpg);
  background-size: cover; */
}

.result-bg {
  background-image: url(/images/egame/header-bg.jpg); /* Replace with your image URL */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  color: #000 !important; /* Adjust text color for better visibility */
}

@media screen and (max-width: 600px) {
  table {
    border: 0;
  }

  table caption {
    font-size: 1.3em;
  }
  
  table thead {
    border: none;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }
  
  table tr {
    border-bottom: 3px solid #ddd;
    display: block;
    margin-bottom: .625em;
  }
  
  table td {
    border-bottom: 1px solid #ddd;
    display: block;
    font-size: .8em;
    text-align: right;
  }
  
  .digits {
    margin-right: unset !important;
  }
  
  table td::before {
    /*
    * aria-label has no advantage, it won't be read inside a table
    content: attr(aria-label);
    */
    content: attr(data-label);
    float: left;
    font-weight: bold;
    text-transform: uppercase;
  }
  
  table td:last-child {
    border-bottom: 0;
  }  
}
</style> -->
